'use strict'

module.exports = Backbone.View.extend

  render: (cardsHtml) ->
    @$el.html(cardsHtml)

  append: (cardsHtml) ->
    @$el.append(cardsHtml)

  insertAfter: (cardsHtml, $card) ->
    $card.after(cardsHtml)
